export default "__VITE_ASSET__Cby0ZX3$__"